module.exports = __webpack_public_path__ + "static/media/ic-gender.c503d172.svg";